/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}          from './project.element';
import {ProjectElementType}      from './project.element.type';
import { BlobType }              from '../blob';

import { Project }               from '../project';

import { Logger }                from '@/util/logger';

import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";

/**
 *
 * @class SimulationElement
 *
 * root element for all the simulations in the project.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
@ProjectElementFactoryDecorator('SimulationElement')
export class SimulationElement extends ProjectElement {

  public actionKeys: string[] = [];

  /** standard constructor */
  constructor(
     project: Project,
          id: string,
      parent: ProjectElement,
       label: string = 'Simulations',
     publish: boolean = false
  ) {

    super(project, id, ProjectElementType.Simulation);

    this._acceptsElements.push(ProjectElementType.SimulationGroup);
    this._acceptsBlobs.push(BlobType.None);

    this._enabled     = true;
    this._label       = label;
    this._icon        = 'fas fa-flag-checkered';
    this._elementKind = 'Simulation';

    if (parent) {

      this._project.addElement(this, parent, publish);
    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring SimulationElement");
  }

  /**
   * subclasses must add their menu item definition(s) to the given action set,
   * in jquery-contextmenu fashion.
   *
   * @param actionSet any
   *
   */
  public actions(actionSet: any): any {

    return super.actions(actionSet);
  }

  /** test if this element accepts the given action */
  public acceptsAction(key: string): boolean {

    return super.acceptsAction(key);
  }

  /** sub-classes must implement their own actions */
  public action(key: string, selection: ProjectElement[]) {

    return super.action(key, selection);
  }

  /** is this element deletable? */
  public isDeletable() : boolean {

    return false;
  }

}
